(function ($, Drupal) {
  Drupal.behaviors.butter_bar = {
    attach: function (context, settings) {
      if ($('#butter-carousel', context).length !== 0) {
        // Initialize the carousel
        let butter_carousel = new Splide('#butter-carousel', {
          arrows: true,
          autoplay: true,
          pagination: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          rewind: true,
          slidesToScroll: 1,
          slidesToShow: 1,
          type: 'loop',
        });

        // Hide the fallback item and show the carousel immediately
        $('.butter-bar__item--1').hide();
        $('#butter-carousel').css('visibility', 'visible');

        // Mount the carousel
        butter_carousel.mount();

        // Reference the existing pause button
        let toggleButton = $('.butter-bar__pause', context);

        // Update button text and aria-label based on autoplay state
        function updateButtonState(isPlaying) {
          if (isPlaying) {
            toggleButton.attr('aria-label', 'Pause autoplay');
            toggleButton.text('Pause sliding');
          } else {
            toggleButton.attr('aria-label', 'Start autoplay');
            toggleButton.text('Resume sliding');
          }
        }

        // Listen for autoplay events to update the button state
        butter_carousel.on('autoplay:play', function () {
          updateButtonState(true);
        });

        butter_carousel.on('autoplay:pause', function () {
          updateButtonState(false);
        });

        // Handle button click to toggle autoplay
        toggleButton.on('click', function () {
          let Autoplay = butter_carousel.Components.Autoplay;

          if (Autoplay.isPaused()) {
            Autoplay.play();
          } else {
            Autoplay.pause();
          }
        });

        // Set initial button state
        updateButtonState(!butter_carousel.Components.Autoplay.isPaused());
      }
    }
  };
})(jQuery, Drupal);